var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.83 67.037"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33054"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a2a2a2",
    fillRule: "evenodd",
    d: "M34.83 33.564 1.267 0 0 1.357l32.207 32.207L0 65.771l1.267 1.267Z",
    "data-name": "Path 44402"
  }))));
};
export default SvgNext;